import React, { Suspense } from 'react';
import { RouteObject, RouterProvider, createBrowserRouter, Navigate } from 'react-router';
import { QUEUE_ROUTES } from './dealers/fresh/routes';

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Navigate to="/queue/dealer/app" replace />
    },
    ...QUEUE_ROUTES,
    {
      path: '*',
      element: (
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '100vh',
          fontFamily: 'Arial, sans-serif'
        }}>
          <h1>404 - Страница не найдена</h1>
          <p>Пожалуйста, используйте правильный URL: /queue/dealer/[ID]</p>
          <a href="/queue/dealer/1" style={{ marginTop: '20px', color: '#007bff' }}>
            Перейти к дилеру #1
          </a>
        </div>
      )
    }
  ] as RouteObject[]);

  return (
    <Suspense fallback={null}>
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default App;
